<template lang='pug'>
div(:class='$style[`cc-question-react`]')
  div(:class='$style[`cc-question-react-wrap`]')
    //- 討論板控制器
    div(:class='$style[`cc-question-react-controller`]')
      //- 推薦
      div(v-if='loginStatus && loginProfile.user_type === `doctor`' :class='[$style[`cc-question-react-controller-btn`], $style[agreeToggle ? `cc-question-react-controller-isAdd` : ``]]' @click='handleQaAgree')
        transition(name='animate-slide-up-fade')
          div(
            v-if='agreeTipToggle'
            :class='$style[`cc-question-react-controller-tip`]')
            span!= '已推薦'
        IconAgree(:size='22' :color='agreeToggle ? `#009fa5` : `#b1b1b1`')
        span(:class='agreeToggle ? `font-doctor-theme` : ``') {{ agreeToggle ? '已推' : '推薦' }}

      //- 給讚
      div(v-if='loginStatus && loginProfile.user_type === `normal`' :class='[$style[`cc-question-react-controller-btn`], $style[likeToggle ? `cc-question-react-controller-isAdd` : ``]]' @click='handleQaLike')
        transition(name='animate-slide-up-fade')
          div(
            v-if='likeTipToggle'
            :class='$style[`cc-question-react-controller-tip`]')
            span!= '已給讚'
        IconLike(:size='22' :color='likeToggle ? `#ef6357` : `#b1b1b1`')
        span(:class='likeToggle ? `font-normal-theme` : ``') {{ likeToggle ? '已讚' : '給讚' }}

      div(
        :class='[$style[`cc-question-react-controller-btn`], $style[bookmarkToggle ? `cc-question-react-controller-isAdd` : ``]]' @click='handleQaAddBookMark')
        transition(name='animate-slide-up-fade')
          div(
            v-if='bookmarkTipToggle'
            :class='$style[`cc-question-react-controller-tip`]')
            span!= '已收藏'
        IconBookMark(:size='22' :color='`#b1b1b1`')
        span {{ bookmarkToggle ? '已收藏' : '加收藏' }}

      div(:class='$style[`cc-question-react-controller-btn`]' @click='handleShowQRcodePopBox')
        IconShare(:size='22' :color='`#b1b1b1`')
        span {{ '分享' }}

      div(:class='$style[`cc-question-react-controller-btn`]' @click='handleClickReportIssue')
        IconWarn2(:size='22' :color='`#b1b1b1`')
        span {{ '檢舉' }}


</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { useShare } from '@vueuse/core'
const { share, isSupported } = useShare();

import IconAgree from '../../icon/Agree';
import IconLike from '../../icon/Like';
import IconBookMark from '../../icon/Bookmark';
import IconShare from '../../icon/Share';
import IconWarn2 from '../../icon/Warn2';

import { debounce } from 'debounce';

import {
  getCurrentDate,
  deleteExistNotify,
  postCreateNewNotify,

  postAddQaBookmark,
  postSendQaAgree,
  postSendQaLike,
  deleteQaBookmark,
  deleteQaAgree,
  deleteQaLike,
} from '../../../js/restapi';

export default {
  components: {
    IconShare,
    IconBookMark,
    IconLike,
    IconAgree,
    IconWarn2,
  },

  props: {
    qid: {
      type: String,
      default: '',
    },
    authorId: {
      type: String,
      default: '',
    },
    isBookmarked: {
      type: Boolean,
      default: false,
    },
    isAgree: {
      type: Boolean,
      default: false,
    },
    isLike: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      agreeToggle: this.isAgree,
      likeToggle: this.isLike,
      bookmarkToggle: this.isBookmarked,

      agreeTipToggle: false,
      likeTipToggle: false,
      bookmarkTipToggle: false,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      // changeQRcodeStatus: 'global/POPQRCODE_STATUS',
      changePopAgreeListStatus: 'global/POPAGREE_LIST_STATUS',
      changePopReportStatus: 'global/POPREPORT_STATUS',
    }),

    handleShowQRcodePopBox() {
      share({
        title: 'Cancell醫抗癌 討論版',
        text: '討論版',
        url: `https://cancell.tw/qa/${this.qid}`,
      });
    },

    // handleShowQRcodePopBox() {
    //   this.changeQRcodeStatus({
    //     active: true,
    //     link: `https://cancell.tw/qa/${this.qid}`,
    //   });
    // },

    handleClickReportIssue() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        if (!this.loginProfile.verified) {
          this.changePopBoxStatus({
            active: true,
            include: 'needVerify',
          });
          return;
        }

        this.changePopReportStatus({
          active: true,
          detail: {
            author_id: `${this.authorId}`,
            content_id: `${this.qid}`,
            type: 'qa',
          },
        });
      }
    },

    handleQaAddBookMark() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        this.bookmarkToggle = !this.bookmarkToggle;
        this.bookmarkDebounceEvent({
          isAdded: this.bookmarkToggle,
        });
      }
    },

    handleQaAgree() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        // 帳號未認證
        if (!this.loginProfile.verified) {
          this.changePopBoxStatus({
            active: true,
            include: 'needVerify',
          });
          return;
        }
        this.agreeToggle = !this.agreeToggle;
        this.agreeDebounceEvent({
          isAdded: this.agreeToggle,
        });
      }
    },

    handleQaLike() {
      if (!this.loginStatus) {
        this.changePopBoxStatus({
          active: true,
          include: 'login',
        });
      } else {
        this.likeToggle = !this.likeToggle;
        this.likeDebounceEvent({
          isAdded: this.likeToggle,
        });
      }
    },

    createNewNotifyEvent(category, eventType) {
      if (`${this.loginDjangoId}` === `${this.authorId}`) {
        console.log('偵測到Remind是同個人!!');
        return;
      }
      getCurrentDate('')
        .then((res) => {
          const POST_DATA = {
            auth_id: `${this.loginDjangoId}`,
            category,
            category_id: `${this.qid}`,
            remind_user_id: `${this.authorId}`,
            remind: 'yes',
            date: `${res.data}`,
            behavior: eventType,
          };

          postCreateNewNotify('', POST_DATA)
            .then((res) => {
              console.log('建立通知成功!!');
            })
            .catch((err) => {
              console.log('建立通知失敗!!');
            });
        })
        .catch((err) => {});
    },

    deleteNotifyEvent(eventType) {
      if (`${this.loginDjangoId}` === `${this.authorId}`) {
        console.log('偵測到Remind是同個人!!');
        return;
      }

      const DELETE_DATA = {
        category_id: `${this.qid}`,
        remind_user_id: `${this.authorId}`,
        auth_id: `${this.loginDjangoId}`,
        behavior: eventType,
      };

      deleteExistNotify('', {
        headers: {
          'content-Type': 'application/json',
        },
        data: JSON.stringify(DELETE_DATA),
      })
        .then((res) => {
          console.log('建立通知成功!!');
        })
        .catch((err) => {
          console.log('建立通知失敗!!');
        });
    },

    // eslint-disable-next-line func-names
    bookmarkDebounceEvent: debounce(function (e) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      const UPDATE_DATA = {
        auth_id: `${this.loginDjangoId}`,
        q_id: `${this.qid}`,
      };

      this.bookmarkTipToggle = false;

      if (e.isAdded) {
        postAddQaBookmark('', UPDATE_DATA, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
          .then((/* response */) => {
            this.bookmarkTipToggle = true;
            this.$emit('sendBookmarkState', true);
            // this.handleUserAddHp(this.loginDjangoId, '+1');
            console.log('%c 新增書籤 成功 :', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');
          })

          .catch((error) => {
            console.error('新增書籤 失敗！', error.message);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      } else {
        // eslint-disable-next-line no-undef
        deleteQaBookmark('', {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
          data: JSON.stringify(UPDATE_DATA),
        })
          .then((/* response */) => {
            this.$emit('sendBookmarkState', false);
            // this.handleUserAddHp(this.loginDjangoId, '-1');
            console.log('%c 刪除書籤 成功', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');
          })

          .catch((error) => {
            console.error('刪除書籤 失敗！', error.response);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      }
    }, 300),

    // eslint-disable-next-line func-names
    agreeDebounceEvent: debounce(function (e) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      const UPDATE_DATA = {
        auth_id: `${this.loginDjangoId}`,
        q_id: `${this.qid}`,
      };

      this.agreeTipToggle = false;

      if (e.isAdded) {
        postSendQaAgree('', UPDATE_DATA, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
          .then((/* response */) => {
            this.agreeTipToggle = true;
            this.$emit('sendAgreeLikeState', true);
            // this.handleUserAddHp(this.loginDjangoId, '+10');
            console.log('%c 推薦 成功 :', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');

            this.createNewNotifyEvent('qa', 'qa-agree');
          })

          .catch((error) => {
            console.error('推薦 失敗！', error.response);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      } else {
        // eslint-disable-next-line no-undef
        deleteQaAgree('', {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
          data: JSON.stringify(UPDATE_DATA),
        })
          .then((/* response */) => {
            this.$emit('sendAgreeLikeState', false);
            // this.handleUserAddHp(this.loginDjangoId, '-10');
            console.log('%c 刪除推薦 成功', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');
            this.deleteNotifyEvent('qa-agree');
          })

          .catch((error) => {
            console.error('刪除推薦 失敗！', error.response);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      }
    }, 300),

    // eslint-disable-next-line func-names
    likeDebounceEvent: debounce(function (e) {
      // const jwtAccess = JSON.parse(this.authJwtToken).a;

      const UPDATE_DATA = {
        auth_id: `${this.loginDjangoId}`,
        q_id: `${this.qid}`,
      };

      this.likeTipToggle = false;

      if (e.isAdded) {
        postSendQaLike('', UPDATE_DATA, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
        })
          .then((/* response */) => {
            this.likeTipToggle = true;
            this.$emit('sendAgreeLikeState', true);
            // this.handleUserAddHp(this.loginDjangoId, '+5');
            console.log('%c 給讚 成功 :', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');

            this.createNewNotifyEvent('qa', 'qa-like');
          })

          .catch((error) => {
            console.error('給讚 失敗！', error.response);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      } else {
        // eslint-disable-next-line no-undef
        deleteQaLike('', {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          },
          data: JSON.stringify(UPDATE_DATA),
        })
          .then((/* response */) => {
            this.$emit('sendAgreeLikeState', false);
            // this.handleUserAddHp(this.loginDjangoId, '-5');
            console.log('%c 刪除給讚 成功', 'padding: 1px 3px 2px 18px; background: linear-gradient(to right, #009fa5 8px, #ef6357 9px, #ef6357 17px, #262626 18px); color: #fff;');
            this.deleteNotifyEvent('qa-like');
          })

          .catch((error) => {
            console.error('刪除給讚 失敗！', error.response);
            if (error.response.status === 401) {
              this.changePopBoxStatus({
                active: true,
                include: 'relogin',
              });
            }
          });
      }
    }, 300),
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
      authJwtToken: 'user/exportUserJwtToken',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/qa/questionReactor.scss';
</style>
